export default __webpack_public_path__ + "static/media/instagram.ea151744.svg";